import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as userActions from '../../global/user/actions/index';
import * as slidesActions from '../actions/index';
import DocumentDropZone from '../document_drop_zone/document_drop_zone';

class EditorIndex extends Component {

    componentDidMount() {
        this.props.onUpdateAuthToken();
    }

    handleFile = (file, addBlankSlides) => {
        this.props.onImportDocument(file, addBlankSlides, (doc) => {
            this.props.history.push('/slides/editor/' + doc.id);
        });
    }

    handleAiFile = (file, customPrompt, addBlankSlides) => {
        this.props.onAiDraftDocument(file, customPrompt, addBlankSlides);
    }

    render() {
        let documents = this.props.documents || [];

        return (
            <div className="w-full flex flex-col bg-gray-100 p-8">
                <div className="max-w-2xl w-full mx-auto">
                    <h1 className="text-2xl font-bold text-gray-800 mb-2">Slide Editor</h1>
                    <p className="text-gray-500 mb-6">Create and edit ProPresenter presentations</p>

                    <div className="flex space-x-4 mb-8">
                        <button
                            className="inline-flex items-center px-4 py-2 bg-blue-500 text-white text-sm font-medium rounded-md hover:bg-blue-600 transition duration-150"
                            onClick={() => {
                                this.props.onCreateDocument(null, (doc) => {
                                    this.props.history.push('/slides/editor/' + doc.id);
                                });
                            }}
                            disabled={this.props.creating_document}
                        >
                            {this.props.creating_document ? 'Creating...' : 'New Document'}
                        </button>
                    </div>

                    <DocumentDropZone
                        onFile={this.handleFile}
                        onAiFile={this.handleAiFile}
                        loading={this.props.importing_document}
                        loadingText="Importing document..."
                        error={this.props.import_error}
                    />

                    {documents.length > 0 && (
                        <div>
                            <h2 className="text-lg font-medium text-gray-700 mb-3">Recent Documents</h2>
                            <div className="grid grid-cols-2 gap-4">
                                {documents.map((doc) => (
                                    <div
                                        key={doc.id}
                                        className="bg-white border border-gray-200 rounded-lg p-4 cursor-pointer hover:border-blue-400 hover:shadow-xs transition duration-150"
                                        onClick={() => this.props.history.push('/slides/editor/' + doc.id)}
                                    >
                                        <div className="w-full h-20 bg-gray-800 rounded-sm mb-3 flex items-center justify-center">
                                            <span className="text-gray-500 text-xs">Presentation</span>
                                        </div>
                                        <p className="text-sm font-medium text-gray-800 truncate">{doc.name}</p>
                                        <p className="text-xs text-gray-400">{new Date(doc.updated_at).toLocaleDateString()}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        documents: state.slides.documents,
        creating_document: state.slides.creating_document,
        importing_document: state.slides.importing_document,
        import_error: state.slides.import_error
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUpdateAuthToken: (callback) => dispatch(userActions.updateAuthToken(callback)),
        onCreateDocument: (name, callback) => dispatch(slidesActions.createDocument(name, callback)),
        onImportDocument: (file, addBlankSlides, callback) => dispatch(slidesActions.importDocument(file, addBlankSlides, callback)),
        onAiDraftDocument: (file, customPrompt, addBlankSlides) => dispatch(slidesActions.aiDraftDocument(file, customPrompt, addBlankSlides)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditorIndex));
